var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { Observable } from 'rxjs';
import { ViewTreeNode } from './models/view.tree-node';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { CameraModel } from './models/camera.model';
import { plainToClass, classToClass } from 'class-transformer';
import { GraphUtils } from 'src/lib/graph/graph-utils';
import { calculateLeafStateMap } from 'src/lib/graph/leaf-state';
import * as i0 from "@angular/core";
import * as i1 from "../../lib/graph/graph.service";
var graphIdKey = 'objectId';
var graphChildKey = 'objects';
var ɵ0 = function (id) { return Human.scene.objects[id].isRenderable(); }, ɵ1 = function (id) { return Human.scene.objects[id].displayName; }, ɵ2 = function (id) { return false; };
var graphProperties = {
    shown: 'shown',
    renderable: ɵ0,
    pickable: 'pickable',
    label: ɵ1,
    expanded: ɵ2
};
var graphPropertySync = {
    shown: 'trueWins',
    renderable: 'falseWins',
    pickable: 'trueWins'
};
var defaultGraphConfig = {
    trim: true
};
var NodeConfig = /** @class */ (function () {
    function NodeConfig() {
    }
    return NodeConfig;
}());
/*
Data specification for per-chapter modifcations to scene graph to create a user facing view graph
*/
var ChapterViewGraphConfig = /** @class */ (function () {
    function ChapterViewGraphConfig(graphData) {
        this.trim = graphData.trim || false;
        this.terminal = graphData.terminal || [];
        this.root = graphData.root || { children: [], replace: false };
        this.connect = graphData.connect || {};
        this.nodes = graphData.nodes || [];
    }
    return ChapterViewGraphConfig;
}());
export var EngineEventsEnum;
(function (EngineEventsEnum) {
    EngineEventsEnum["Loaded"] = "loaded";
    EngineEventsEnum["Tick"] = "tick";
    EngineEventsEnum["AssetsLoadStart"] = "assets.load.start";
    EngineEventsEnum["AssetsLoadProgress"] = "assets.load.progress";
    EngineEventsEnum["AssetsLoadFinish"] = "assets.load.finish";
    EngineEventsEnum["ModulesCreateFinish"] = "modules.create.finish";
    EngineEventsEnum["ModulesDestroryFinish"] = "modules.destroy.finish";
    // ModuleInteractive = 'module.interactive',
    EngineEventsEnum["ModulesActivateFinish"] = "modules.activate.finish";
    EngineEventsEnum["SceneObjectsShown"] = "scene.objectsShown";
    EngineEventsEnum["SceneMarkersUpdated"] = "scene.markers.updated";
    EngineEventsEnum["SceneObjectRenderable"] = "scene.objectRenderable";
    EngineEventsEnum["TimelineChaptersActivateFinish"] = "timeline.chapters.activate.finish";
    EngineEventsEnum["TimelineChaptersActivateStart"] = "timeline.chapters.activate.start";
    EngineEventsEnum["TimelineScrubbed"] = "timeline.scrubbed";
    EngineEventsEnum["TimelinePlay"] = "timeline.play";
    EngineEventsEnum["TimelinePlaying"] = "timeline.playing";
    EngineEventsEnum["TimelineStop"] = "timeline.stop";
    EngineEventsEnum["HotspotsPositionUpdated"] = "hotspots.positionUpdated";
})(EngineEventsEnum || (EngineEventsEnum = {}));
var EngineService = /** @class */ (function () {
    function EngineService(graphService) {
        var _this = this;
        this.graphService = graphService;
        // #TODO: [EM] these maps should be in state
        this.objectToNodeMap = {}; // one object id in the engine maps to one node in the view graph
        this.nodeToObjectMap = {}; // one node in the view graph maps to one or more engine object ids.
        /**
         * Maps Human.events from the engine in application observables so that we can subscribe, filter, buffer
         * and more without needing direct knowlege of the Human library across the application.
         */
        this.events = {};
        this.events = Object.values(EngineEventsEnum)
            .reduce(function (result, event) {
            result[event] = _this.makeObservable(event);
            return result;
        }, {});
    }
    EngineService.prototype.makeObservable = function (event) {
        return Observable.create(function (observer) {
            Human.events.on(event, function (params) {
                observer.next(params);
            });
        });
    };
    EngineService.prototype.getCanvas = function () {
        return Human.renderer.canvas.canvas;
    };
    EngineService.prototype.getEvent = function (event) {
        return this.events[event];
    };
    EngineService.prototype.fireEvent = function (event, params) {
        Human.events.fire(event, params);
    };
    // set 'shown' attribute of specified nodes to specifed value and synchronize viewGraph
    EngineService.prototype.toggleNodes = function (nodeIds, visible) {
        // handles the conversion of view graph nodes to engine objects
        var _this = this;
        // Bind fetchAssets to visible, so that any time a node is set to visible the engine
        // will attempt to load it's assets (if they haven't been loaded already)
        var config = { replace: false, objects: {}, fetchAssets: visible };
        nodeIds.forEach(function (nodeId) {
            _this.getObjects(nodeId).forEach(function (humanObjectId) {
                config.objects[humanObjectId] = visible;
            });
        });
        Human.scene.setEnabledObjects(config);
    };
    /**
    * Sets the specified nodes pickable state (including leaves)
    */
    EngineService.prototype.setNodesPickable = function (viewGraph, nodeIds, pickable) {
        var _this = this;
        // #TODO[AC]? The engine doesn't emit event of pick changes, track via state map
        var changeStateMap = {};
        nodeIds.forEach(function (nodeId) {
            var object = Human.scene.objects[nodeId];
            // set node pickable, else leaves
            var pickableNodeIds = object.isLeaf() ? [nodeId] : _this.getLeafObjects(nodeId);
            changeStateMap[nodeId] = { pickable: pickable };
            pickableNodeIds.forEach(function (pickableNodeId) {
                var pickableObject = Human.scene.objects[pickableNodeId];
                pickableObject.setPickable(pickable);
                // track object state
                changeStateMap[pickableNodeId] = { pickable: pickable };
            });
        });
        return changeStateMap;
    };
    // build a BdGraph object representing the engine's scene
    EngineService.prototype.createViewGraph = function (config) {
        var _this = this;
        // Create Synchronized Graph from Roots
        var viewGraph = GraphUtils.createGraphFromSrc(Human.scene.rootObjects, graphIdKey, graphChildKey, graphProperties);
        this.graphService.synchronize(viewGraph, graphPropertySync);
        // save a copy of the scene graph for future use
        this.sceneGraph = classToClass(viewGraph);
        var needsResync = false; // set to true when reconnecting;
        // ViewGraphConfig: build custom nodes
        config.nodes.forEach(function (nodeConfig) {
            var customNode = new ViewTreeNode(nodeConfig);
            customNode.label = nodeConfig.displayName;
            customNode.boolState.shown = true;
            _this.graphService.addRootNode(viewGraph, customNode);
        });
        // ViewGraphConfig: reconnect nodes
        Object.entries(config.connect).forEach(function (_a) {
            var _b = __read(_a, 2), id = _b[0], connections = _b[1];
            var removed = _this.graphService.resetAsParent(viewGraph, id, connections.children, connections.replace);
            removed.forEach(function (rid) {
                _this.nodeToObjectMap[id] = __spread(_this.nodeToObjectMap[id] || [], [rid]);
                _this.objectToNodeMap[rid] = id;
            });
            needsResync = true; // this could change the state of viewgraph group nodes
        });
        // ViewGraphConfig: terminal nodes
        config.terminal.forEach(function (id) {
            _this.graphService.resetAsLeaf(viewGraph, id).forEach(function (removedId) {
                _this.objectToNodeMap[removedId] = id;
                _this.nodeToObjectMap[id] = __spread(_this.nodeToObjectMap[id] || [], [removedId]);
            }, _this);
        }, this);
        // ViewGraphConfig: re-root nodes
        var viewRoots = config.root.children ? config.root.children : [];
        if (!config.root.replace) {
            Human.scene.rootObjects.forEach(function (humanRoot) {
                viewRoots = __spread(viewRoots, humanRoot.objects.map(function (ho) { return ho.objectId; }));
            });
        }
        this.graphService.resetAsParent(viewGraph, null, viewRoots, true);
        // Full Sync after re-connection
        this.graphService.resetDepth(viewGraph);
        this.graphService.synchronize(viewGraph, graphPropertySync);
        if (needsResync) {
            this.graphService.synchronize(viewGraph, graphPropertySync);
        }
        return viewGraph;
    };
    // translate engine's object id to the representative view node
    EngineService.prototype.getNode = function (viewGraph, id) {
        if (this.graphService.nodeExists(viewGraph, id)) {
            // object exists in view graph
            return GraphUtils.getNode(viewGraph, id);
        }
        else if (this.objectToNodeMap[id]) {
            // object is masked 
            return GraphUtils.getNode(viewGraph, this.objectToNodeMap[id]);
        }
        else {
            // no available node
            return null;
        }
    };
    // #TODO[EM]: this should be in state, harvested from chapter object on load
    // getChapterData
    EngineService.prototype.getChapterGraphConfig = function () {
        var c = Human.timeline.activeRoot._nowBranch;
        return new ChapterViewGraphConfig(__assign({}, defaultGraphConfig, c.graph || {}));
    };
    EngineService.prototype.getRootObjects = function () {
        // TODO.. type this
        return Human.scene.rootObjects;
    };
    EngineService.prototype.getAllSceneObjects = function () {
        return Human.scene.objects;
    };
    // given a view node id, return the corresponding human object-id
    EngineService.prototype.getObjects = function (id) {
        if (this.nodeToObjectMap[id]) {
            return this.nodeToObjectMap[id];
        }
        else {
            return [Human.scene.objects[id].objectId] || [];
        }
    };
    // given a view node id, return the corresponding leaf human-object ids
    // #NOTE: [EM] This is stateful and could benefit from pre-caching viewNodeId -> human leaf objects
    EngineService.prototype.getLeafObjects = function (id) {
        if (id in this.nodeToObjectMap) {
            var leaves_1 = {};
            this.nodeToObjectMap[id].forEach(function (objectId) {
                if (Human.scene.objects[objectId].isLeaf()) {
                    leaves_1[objectId] = true;
                }
                else {
                    Human.scene.getLeaves(objectId).forEach(function (leafId) {
                        leaves_1[leafId] = true;
                    });
                }
            });
            return Object.keys(leaves_1);
        }
        else if (id in Human.scene.objects) {
            return Human.scene.getLeaves(id);
        }
        else {
            return [];
        }
    };
    EngineService.prototype.getChapter = function (id) {
        return Human.timeline.branchTimelines[id] || null;
    };
    EngineService.prototype.getActiveChapters = function () {
        if (Human.timeline.activeRoot) {
            return Human.timeline.activeRoot._chapters;
        }
        else {
            return [];
        }
    };
    // return bounding box of objects
    EngineService.prototype.getBoundaryFromObjects = function (objectIds) {
        objectIds = objectIds.filter(function (x) { return Human.scene.objects[x].isLeaf(); });
        return Human.scene.getBoundary({ objectIds: objectIds, clipped: true });
    };
    EngineService.prototype.getLeaves = function (objectId) {
        return Human.scene.getLeaves(objectId);
    };
    // get visible leaves
    EngineService.prototype.getVisibleLeaves = function () {
        return Human.scene.getEnabledLeaves();
    };
    // get camera lookat
    EngineService.prototype.getCameraLookAt = function () {
        return plainToClass(CameraModel, Human.renderer.camera.getLookAt());
    };
    // get world position from barycentric coordiantes
    EngineService.prototype.barycentricToWorld = function (objectId, primitiveIndex, barycentric, renderableIndex) {
        if (renderableIndex === void 0) { renderableIndex = 0; }
        var out = new Float32Array([0, 0, 0]);
        var humanObject = Human.scene.objects[objectId];
        humanObject.barycentricToWorldSpace(renderableIndex, primitiveIndex, barycentric, out);
        return !isNaN(out[0]) ? __spread(Array.from(out)) : [0, 0, 0];
    };
    EngineService.prototype.setGraphState = function (synchronization) {
        Human.scene.setObjectProperties(synchronization);
    };
    // return a list of all states (namespaces) with assets loaded in the engine
    EngineService.prototype.getAssetNamespaces = function () {
        var namespaces = {};
        Object.keys(Human.assets.loadedAssets).map(function (wholeId) { return wholeId.split('/')[0]; }).forEach(function (namespace) {
            namespaces[namespace] = true;
        });
        return Object.keys(namespaces);
    };
    // [SCENE QUERY] Return objects shown in at least one chapter
    EngineService.prototype.queryShownObjects = function (chapters, wholeGraph) {
        var _this = this;
        if (wholeGraph === void 0) { wholeGraph = true; }
        var shown = {};
        chapters.forEach(function (chapter) {
            // #NOTE: [EM] This could be extended to include otehr 'shown' conditions e.g. clipped, opacity, etc.
            var leafStateMap = calculateLeafStateMap(_this.sceneGraph, chapter.synchronization, ['shown']);
            for (var id in leafStateMap) {
                if (leafStateMap.hasOwnProperty(id)) {
                    shown[id] = (shown[id] || false) || leafStateMap[id].shown;
                }
            }
        });
        var result = shown;
        if (wholeGraph) {
            // create leaf state map from property maps
            var leafStateMap = this.graphService.createGraphStateMapFromPropertyMaps({ 'shown': shown });
            var graphStateMap = this.graphService.calculateGraphStateMap(this.sceneGraph, { 'shown': 'trueWins' }, leafStateMap, true);
            result = this.graphService.extractPropertymapFromGraphState(graphStateMap, 'shown');
        }
        return result;
    };
    // load assets for graph objects if they exist 
    EngineService.prototype.loadGraphObject = function (id) {
        var humanObjects = this.getObjects(id).map(function (objectId) { return Human.scene.objects[objectId]; });
        return new Observable(function (observer) {
            // load default asset types
            Human.scene.graph.attachAssetSetsToSubtree(humanObjects, null, function () {
                observer.next(true);
                observer.complete();
            });
        });
    };
    EngineService.ngInjectableDef = i0.defineInjectable({ factory: function EngineService_Factory() { return new EngineService(i0.inject(i1.BdGraphService)); }, token: EngineService, providedIn: "root" });
    return EngineService;
}());
export { EngineService };
export { ɵ0, ɵ1, ɵ2 };
